import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';
import { PropertyInterface } from '@miq/shared-models';
/*
 * L2-R6: moved from `src/app/shared/components/editing-box/editing-box-target.directive.ts`
 * (4 reports references). Confirmed it needs NONE of the editing-box services: it only tags the
 * host element with an `editing-box-target` class when the column has an `edpUpdateConf`, so the
 * services (EditingBoxService and friends) stay in the app. The old host path is a re-export shim.
 */
@Directive({ selector: '[miqEditingBoxTarget]' })
export class EditingBoxTargetDirective implements OnInit {
  private readonly el = inject(ElementRef);
  miqEditingBoxTarget = input<PropertyInterface>(undefined, { alias: 'miqEditingBoxTarget' });
  ngOnInit() {
    const { edpUpdateConf } = this.miqEditingBoxTarget();
    if (edpUpdateConf && this.el) {
      const currentClass = this.el.nativeElement.className || '';
      if (!currentClass.includes('editing-box-target')) {
        this.el.nativeElement.className = `${currentClass} editing-box-target`;
      }
    }
  }
}
